var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueLoadingOverlay',{attrs:{"active":_vm.loading,"is-full-page":true},on:{"update:active":function($event){_vm.loading=$event}}}),_vm._v(" "+_vm._s(_vm.message)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }